/**
 * Status tones: the tinted pill colours (StatusPill) and the matching bar
 * colours, so a state reads the same in a table and in a chart. The text
 * always names the state; colour only groups.
 */

export const TONES = {
  good: { color: "var(--status-good)", background: "var(--status-good-bg)" },
  warning: { color: "var(--status-warning)", background: "var(--status-warning-bg)" },
  critical: { color: "var(--status-critical)", background: "var(--status-critical-bg)" },
  info: { color: "var(--status-info)", background: "var(--status-info-bg)" },
  neutral: { color: "var(--status-neutral)", background: "var(--status-neutral-bg)" },
};

/** The colour of a tone, for bars and markers. */
export const toneColor = (tone) => (TONES[tone] ?? TONES.neutral).color;
